import { render, staticRenderFns } from "./Servicios.vue?vue&type=template&id=141898ba&"
import script from "./Servicios.vue?vue&type=script&lang=ts&"
export * from "./Servicios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports